// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "415574b99b04d4cb1193e0b53531abc40797c686/static/css/" + chunkId + "." + "f83a2947" + ".chunk.css";
};